import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
